module.exports = __webpack_public_path__ + "media/images/grow_drawing-77142c11528bc58010332f119a966e3e.png";